import styled, { css } from 'styled-components';
import { fontBody } from 'Styles/fonts';
import { grey60 } from 'Styles/colors';

export const Limit = styled.div`
  ${fontBody(12)};
  position: absolute;
  right: 12px;
  top: 4px;
  color: ${grey60};
  opacity: 0;
  transition: opacity 0.1s;

  ${({ isFocused, isEmpty }) =>
    (!isEmpty || isFocused) &&
    css`
      opacity: 1;
    `}
`;

export default {};
